import { useDispatch } from 'react-redux';

import { DatasetActions } from '../redux-store/thunks/datasets.thunks';

export const useLoadInternalDatasets = (token: string) => {
  const dispatch = useDispatch();

  const loadInternalDatasets = async () => {
    if (!token) {
      return;
    }

    dispatch(DatasetActions.loadAllInternals());
  };

  return { loadInternalDatasets };
};
